<p-button
  [type]="type"
  [style]="{
    width: width,
    height: height,
    borderRadius: borderradius,
    fontFamily: fontFamily
  }"
  [label]="label ? label : ''"
  [disabled]="disabled"
  (onClick)="onClick()"
></p-button>
